export const hideRFID = (rfid?: string) => {
  if (!rfid) return "";
  return `****${rfid.slice(-2)}`;
};
